var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "Box" },
    [
      _c(
        "el-form",
        { staticClass: "selectClass", attrs: { "label-position": "top" } },
        [
          _c(
            "el-row",
            {
              staticStyle: { "flex-wrap": "wrap" },
              attrs: { type: "flex", justify: "start" },
            },
            [
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "template",
                        { slot: "label" },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "orderNumClass",
                              attrs: {
                                placeholder: _vm.$t(
                                  "GlobalSetObj.pleaseChoose"
                                ),
                                size: "small",
                              },
                              on: { change: _vm.changeNum },
                              model: {
                                value: _vm.chooseNumber,
                                callback: function ($$v) {
                                  _vm.chooseNumber = $$v
                                },
                                expression: "chooseNumber",
                              },
                            },
                            [
                              _c("el-option", {
                                key: "1",
                                attrs: {
                                  label: _vm.$t(
                                    "orderCenterCont.anjunWaybillNumber"
                                  ),
                                  value: 1,
                                },
                              }),
                              _c("el-option", {
                                key: "2",
                                attrs: {
                                  label: _vm.$t("navbar.anjunOrderNumber"),
                                  value: 2,
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c("el-input", {
                        attrs: {
                          placeholder: _vm.$t("collectionCenter.max2000Line"),
                          clearable: "",
                          type: "textarea",
                        },
                        on: { blur: _vm.ft },
                        nativeOn: {
                          keydown: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.BlockNewNumberline($event)
                          },
                        },
                        model: {
                          value: _vm.orderNumber,
                          callback: function ($$v) {
                            _vm.orderNumber = $$v
                          },
                          expression: "orderNumber",
                        },
                      }),
                    ],
                    2
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("collectionCenter.CustomerN") } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            placeholder: _vm.$t(
                              "GlobalSetObj.Only10AreDisplayed"
                            ),
                            filterable: "",
                            clearable: "",
                            remote: "",
                            "reserve-keyword": "",
                            "remote-method": _vm.getCustomerOption,
                          },
                          on: {
                            clear: function ($event) {
                              return _vm.getCustomerOption("")
                            },
                          },
                          model: {
                            value: _vm.queryForm.params.customerId,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryForm.params, "customerId", $$v)
                            },
                            expression: "queryForm.params.customerId",
                          },
                        },
                        _vm._l(_vm.customerOption, function (item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: {
                              label:
                                item.customerAlias +
                                "（" +
                                item.username +
                                "）",
                              value: item.id,
                            },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("collectionCenter.OperationSite"),
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            placeholder: _vm.$t(
                              "GlobalSetObj.Only10AreDisplayed"
                            ),
                            clearable: "",
                            filterable: "",
                            remote: "",
                            "reserve-keyword": "",
                            "remote-method": _vm.remoteGetSiteList,
                          },
                          on: { clear: _vm.remoteGetSiteList },
                          model: {
                            value: _vm.queryForm.params.siteId,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryForm.params, "siteId", $$v)
                            },
                            expression: "queryForm.params.siteId",
                          },
                        },
                        _vm._l(_vm.siteList, function (item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: { label: item.name, value: item.id },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("collectionCenter.operator") } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            placeholder: _vm.$t(
                              "GlobalSetObj.Only10AreDisplayed"
                            ),
                            clearable: "",
                            filterable: "",
                            remote: "",
                            "reserve-keyword": "",
                            "remote-method": _vm.getOperator,
                          },
                          on: { clear: _vm.getOperator },
                          model: {
                            value: _vm.queryForm.params.operatorUser,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.queryForm.params,
                                "operatorUser",
                                $$v
                              )
                            },
                            expression: "queryForm.params.operatorUser",
                          },
                        },
                        _vm._l(_vm.operatorList, function (item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: {
                              label:
                                item.realName + "（" + item.username + "）",
                              value: item.id,
                            },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("basicData.OperationTime") } },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          clearable: true,
                          "default-time": ["00:00:00", "23:59:59"],
                          "end-placeholder": _vm.$t("collectionCenter.EndTime"),
                          "range-separator": _vm.$t("collectionCenter.to"),
                          "start-placeholder": _vm.$t(
                            "collectionCenter.StartTime"
                          ),
                          type: "datetimerange",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                        },
                        on: { change: _vm.dateChange },
                        model: {
                          value: _vm.timeValue,
                          callback: function ($$v) {
                            _vm.timeValue = $$v
                          },
                          expression: "timeValue",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("el-col", { attrs: { span: 6 } }, [
                _c(
                  "div",
                  {
                    staticStyle: {
                      margin: "30px auto",
                      "text-align": "center",
                    },
                  },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { size: "mini", type: "primary" },
                        on: { click: _vm.searchClick },
                      },
                      [
                        _vm._v(
                          " " + _vm._s(_vm.$t("operationCenter.Procurar")) + " "
                        ),
                      ]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { size: "mini", type: "info" },
                        on: { click: _vm.resetClick },
                      },
                      [
                        _vm._v(
                          " " + _vm._s(_vm.$t("collectionCenter.reset")) + " "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c("el-divider"),
      _c(
        "div",
        { staticStyle: { "margin-bottom": "20px" } },
        [
          _c(
            "el-button",
            {
              attrs: { size: "mini", type: "success" },
              on: { click: _vm.chooseDownload },
            },
            [_vm._v(_vm._s(_vm.$t("collectionCenter.export1")))]
          ),
          _c(
            "el-button",
            {
              attrs: { size: "mini", type: "success" },
              on: { click: _vm.downloadAll },
            },
            [_vm._v(_vm._s(_vm.$t("collectionCenter.allExport")))]
          ),
        ],
        1
      ),
      _c(
        "el-table",
        {
          ref: "tableRef",
          attrs: { data: _vm.tableDate, "max-height": 600, border: "" },
          on: { select: _vm.batchSelect, "select-all": _vm.batchSelect },
        },
        [
          _c("el-table-column", { attrs: { type: "selection", width: "55" } }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("collectionCenter.ind"),
              align: "center",
              type: "index",
              width: "60",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          (_vm.queryForm.pageNumber - 1) *
                            _vm.queryForm.pageSize +
                            scope.$index +
                            1
                        )
                      ),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("orderCenterCont.anjunWaybillNumber"),
              prop: "waybillNumber",
              align: "center",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("collectionCenter.orderNumberWithTotal"),
              prop: "orderNumber",
              align: "center",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("div", [
                      _vm._v(
                        _vm._s(scope.row.orderNumber) +
                          "（" +
                          _vm._s(scope.row.waybillCount) +
                          "）"
                      ),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("orderCenterCont.CustomerName"),
              prop: "customerName",
              align: "center",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("collectionCenter.transitWeight"),
              prop: "transportWeight",
              align: "center",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("collectionCenter.orderWeightKG"),
              prop: "weight",
              align: "center",
            },
          }),
          _c(
            "el-table-column",
            {
              attrs: { prop: "weightDifference", align: "center" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c(
                        "div",
                        {
                          style: scope.row.weightDifferenceColor
                            ? "color: red"
                            : "",
                        },
                        [_vm._v(" " + _vm._s(scope.row.weightDifference) + " ")]
                      ),
                    ]
                  },
                },
              ]),
            },
            [
              _c(
                "template",
                { slot: "header" },
                [
                  _c(
                    "el-tooltip",
                    {
                      staticClass: "item",
                      attrs: { effect: "dark", placement: "top" },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            "font-size": "14px",
                            "line-height": "20px",
                          },
                          attrs: { slot: "content" },
                          slot: "content",
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t("collectionCenter.calculationRule")
                              ) +
                              " "
                          ),
                          _c("br"),
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t("collectionCenter.weightComparisonRule")
                              ) +
                              " "
                          ),
                          _c("br"),
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t("collectionCenter.weightComparisonRule2")
                              ) +
                              " "
                          ),
                        ]
                      ),
                      _c("div", [
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t("collectionCenter.weightDifference"))
                        ),
                        _c("i", { staticClass: "el-icon-question" }),
                      ]),
                    ]
                  ),
                ],
                1
              ),
            ],
            2
          ),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("collectionCenter.transitMeasurement"),
              prop: "receiveVolumeWeight",
              align: "center",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("collectionCenter.volumeWeight"),
              prop: "volumeWeight",
              align: "center",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("collectionCenter.orderVolume"),
              prop: "volume",
              align: "center",
            },
          }),
          _c(
            "el-table-column",
            {
              attrs: {
                label: _vm.$t("collectionCenter.volumeDifference"),
                prop: "volumeDifference",
                align: "center",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c(
                        "div",
                        {
                          style: scope.row.volumeDifferenceColor
                            ? "color: red"
                            : "",
                        },
                        [_vm._v(" " + _vm._s(scope.row.volumeDifference) + " ")]
                      ),
                    ]
                  },
                },
              ]),
            },
            [
              _c(
                "template",
                { slot: "header" },
                [
                  _c(
                    "el-tooltip",
                    {
                      staticClass: "item",
                      attrs: { effect: "dark", placement: "top" },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            "font-size": "14px",
                            "line-height": "20px",
                          },
                          attrs: { slot: "content" },
                          slot: "content",
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t("collectionCenter.volumeCalculationRule")
                              ) +
                              " "
                          ),
                          _c("br"),
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t(
                                  "collectionCenter.volumeComparisonWarning"
                                )
                              ) +
                              " "
                          ),
                          _c("br"),
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t("collectionCenter.volumeDecreaseWarning")
                              ) +
                              " "
                          ),
                        ]
                      ),
                      _c("div", [
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t("collectionCenter.volumeDifference"))
                        ),
                        _c("i", { staticClass: "el-icon-question" }),
                      ]),
                    ]
                  ),
                ],
                1
              ),
            ],
            2
          ),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("collectionCenter.controlsEmployee"),
              prop: "operateUserName",
              align: "center",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("collectionCenter.OperationSite"),
              prop: "operateSiteName",
              align: "center",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("operationCenter.operationTime"),
              prop: "operateTime",
              align: "center",
            },
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "right" },
        [
          _c("el-pagination", {
            staticStyle: { margin: "10px 0" },
            attrs: {
              "current-page": _vm.queryForm.pageNumber,
              "page-size": _vm.queryForm.pageSize,
              "page-sizes": [10, 20, 50, 100, 500, 1000, 2000],
              total: _vm.total,
              background: "",
              layout: "total, sizes, prev, pager, next, jumper",
            },
            on: {
              "update:currentPage": function ($event) {
                return _vm.$set(_vm.queryForm, "pageNumber", $event)
              },
              "update:current-page": function ($event) {
                return _vm.$set(_vm.queryForm, "pageNumber", $event)
              },
              "update:pageSize": function ($event) {
                return _vm.$set(_vm.queryForm, "pageSize", $event)
              },
              "update:page-size": function ($event) {
                return _vm.$set(_vm.queryForm, "pageSize", $event)
              },
              "current-change": _vm.searchClick1,
              "size-change": _vm.searchClick,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }